import { GENERATED_PATCH_NOTES } from './patchNotes.generated';

export interface PatchNotesEntry {
  version: string;
  title: string;
  file: string;
}

const compareVersions = (left: string, right: string) => {
  const leftParts = left.split('.').map((part) => Number(part));
  const rightParts = right.split('.').map((part) => Number(part));
  const length = Math.max(leftParts.length, rightParts.length);

  for (let index = 0; index < length; index += 1) {
    const leftPart = leftParts[index] ?? 0;
    const rightPart = rightParts[index] ?? 0;

    if (leftPart !== rightPart) {
      return leftPart - rightPart;
    }
  }

  return 0;
};

export const PATCH_NOTES: PatchNotesEntry[] = [...GENERATED_PATCH_NOTES]
  .sort((left: PatchNotesEntry, right: PatchNotesEntry) =>
    compareVersions(right.version, left.version)
  );

export const CURRENT_PATCH_NOTES = PATCH_NOTES[0];
